export default "<app-recomendaciones [products]=\"products\" ></app-recomendaciones>\n";